export const SET_FOLDERS = 'contentLibraryTypes/SET_FOLDERS';
export const SET_ACTIVE_FOLDER = 'contentLibraryTypes/SET_ACTIVE_FOLDER';
export const SET_FOLDER_CONTENTS = 'contentLibraryTypes/SET_FOLDER_CONTENTS';
export const UPDATE_FOLDERS = 'contentLibraryTypes/UPDATE_FOLDERS';
export const UPDATE_FOLDER_NAME = 'contentLibraryTypes/UPDATE_FOLDER_NAME';
export const UPDATE_FOLDER_CONTENT = 'contentLibraryTypes/UPDATE_FOLDER_CONTENT';
export const DELETE_FOLDER = 'contentLibraryTypes/DELETE_FOLDER';
export const DELETE_FOLDER_CONTENT = 'contentLibraryTypes/DELETE_FOLDER_CONTENT';
export const SET_LOADING = 'contentLibraryTypes/SET_LOADING';
export const UPDATE_CONTENT_NAME = 'contentLibraryTypes/UPDATE_CONTENT_NAME';

export const UPDATE_CONTENT_INSERTION_METHOD = {
    APPEND: 'APPEND',
    PREPEND: 'PREPEND',
};
